import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CdwIconModule } from '@cdw-ae/common-ui-components-icon';
import { CdwDropdownMenuComponent } from './cdw-dropdown-menu/cdw-dropdown-menu.component';

@NgModule({
  imports: [CommonModule, MatMenuModule, MatButtonModule, MatIconModule, MatDividerModule, MatTooltipModule, CdwIconModule],
  declarations: [CdwDropdownMenuComponent],
  exports: [CdwDropdownMenuComponent],
})
export class CdwDropdownMenuModule {}
